import { useForm as useFormHook } from "hooks";
import type { OnboardingBankingAndFinance as OnboardingBankingAndFinanceType } from "features/ecommerce/types";
import {
    FormField,
    type OnboardingBankingAndFinance,
    type OnboardingBankingAndFinanceForm
} from "./types";
import useValidationSchema from "./useValidationSchema";

export const getInitialValues = (
    {
        accountHolderName,
        bankName,
        iban,
        swift,
        ...restInitialValues
    }: Partial<OnboardingBankingAndFinanceType>
): OnboardingBankingAndFinance => ({
    [FormField.AccountHolderName]: accountHolderName ?? '',
    [FormField.BankName]: bankName ?? '',
    [FormField.Iban]: iban ?? '',
    [FormField.Swift]: swift ?? '',
    [FormField.ProofFileKey]: null,
    [FormField.Currency]: null,
    [FormField.AvgTransactionSize]: '',
    [FormField.MonthlyIncome]: '',
    [FormField.TransactionVolume]: '',
    ...restInitialValues
});

export const useForm = (onboardingBankingAndFinance: OnboardingBankingAndFinanceForm) =>
    useFormHook({
        isInitialValid: false,
        ...onboardingBankingAndFinance,
        validateOnMount: true,
        validationSchema: useValidationSchema()
    });
